import React from "react";
import styled from "@emotion/styled";
import { Link } from "gatsby";
import MainEvent from "images/main-event.png";

const Header = styled.div`
  position: relative;
  height: calc(100vh - 76px);
  margin-top: 76px;
  max-width: 100% !important;
  font-weight: bold;
  overflow: hidden;

  > video {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
  }

  > div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    width: 90%;
  }

  @media (max-width: 600px), (max-height: 800px) {
    height: calc(100vh - 50px);
    margin-top: 50px;

    img {
      width: 200px;
    }
  }
`;

const Desc = styled.p`
  font-size: 30px;
  line-height: 38px;
  max-width: 500px;
  margin: 40px auto;

  @media (max-width: 600px), (max-height: 800px) {
    font-size: 24px;
    line-height: 26px;
  }
`;

const Lokasi = styled.p`
  font-size: 24px;
  margin: 0;

  @media (max-width: 600px), (max-height: 800px) {
    font-size: 16px;
  }
`;

const Tanggal = styled.p`
  margin: 18px 0;
  font-size: 24px;
  font-weight: normal;

  @media (max-width: 600px), (max-height: 800px) {
    font-size: 16px;
    margin-top: 0;
  }
`;

const Line = styled.div`
  height: 3px;
  width: 90px;
  background-color: #f0e500;
  margin: 0 auto;
`;

const Button = styled.button`
  margin-top: 40px;
  padding: 20px 84px;
  color: #000;
  font-size: 22px;
  border-radius: 41px;
  background-color: #f0e500;
  border: none;
  font-weight: bold;
  cursor: pointer;

  @media (max-width: 600px), (max-height: 800px) {
    font-size: 16px;
    padding: 12px 54px;
  }
`;

export default function HeaderMain() {
  return (
    <Header>
      <video autoPlay={true} loop={true} muted={true}>
        <source
          src="https://compfest.s3.ap-southeast-1.amazonaws.com/me-bg.mp4"
          type="video/mp4"
        />
      </video>
      <div>
        <img src={MainEvent} />
        <Desc>A Melting pot of 60++ startups and future innovators</Desc>
        <Lokasi>Balairung Universitas Indonesia</Lokasi>
        <Tanggal>28th - 29th September 2019</Tanggal>
        <Line />
        <Link to="/play">
          <Button>PLAY</Button>
        </Link>
      </div>
    </Header>
  );
}
